import { Fact } from "../../../models/fact";
import { ApproximateTime } from "../../../models/human_time";
import { Person, PersonId } from "../../../models/person";
import { Coding } from "../../../models/structuration";
import { isApproximateTime } from "../../../shared/utils/fact";
import { DEATH_CONCEPT_CODE } from "../../../shared/constants/concept";

// Helper function to process family name fact
const processFamilyName = (fact: Fact): string => {
  return typeof fact.value === "string" ? fact.value : "";
};

// Helper function to process given name fact
const processGivenName = (fact: Fact): string => {
  return typeof fact.value === "string" ? fact.value : "";
};

// Helper function to process birth date fact
const processBirthDate = (fact: Fact): ApproximateTime | null => {
  return isApproximateTime(fact.time) ? fact.time : null;
};

// Helper function to process death fact
const processDeathFact = (
  fact: Fact
): { deceased: boolean; deceased_date: ApproximateTime | null } => {
  return {
    deceased: true,
    deceased_date: isApproximateTime(fact.time) ? fact.time : null,
  };
};

// Helper function to process gender fact
const processGender = (fact: Fact): string => {
  return typeof fact.value === "string" ? fact.value : "Male";
};

// Helper function to process individual fact based on code
const processFact = (fact: Fact, attributes: any) => {
  const coding: Coding[] = fact.code.coding;
  const code = coding[0].code;

  switch (code) {
    case "FAMILY_NAME":
      attributes.family_name = processFamilyName(fact);
      break;
    case "GIVEN_NAME":
      attributes.given_name = processGivenName(fact);
      break;
    case "BIRTH_DATE":
      attributes.birth_date = processBirthDate(fact);
      break;
    case DEATH_CONCEPT_CODE: {
      const deathInfo = processDeathFact(fact);
      attributes.deceased = deathInfo.deceased;
      attributes.deceased_date = deathInfo.deceased_date;
      break;
    }
    case "GENDER":
      attributes.gender = processGender(fact);
      break;
  }
};

export const fillAttributes = (facts: Fact[]) => {
  const attributes = {
    given_name: "",
    family_name: "",
    birth_date: null as ApproximateTime | null,
    gender: "Male",
    deceased: false,
    deceased_date: null as ApproximateTime | null,
  };

  facts.forEach((fact) => {
    processFact(fact, attributes);
  });

  return {
    person_id: "" as PersonId,
    family_name: attributes.family_name,
    given_name: attributes.given_name,
    birth_date: attributes.birth_date,
    gender: attributes.gender,
    deceased: attributes.deceased,
    deceased_date: attributes.deceased_date,
    external_ids: [],
    consent_withdrawal_date: null,
  } as Person;
};
